(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function getGalleryIndex(gallery) {
      var w = gallery.clientWidth;
      return w > 0 ? Math.round(gallery.scrollLeft / w) : 0;
    }

    function navigate(zoomEl, index) {
      var gal = zoomEl.querySelector('.dialog-zoomed-gallery');
      if (gal) gal.scrollTo({ left: index * gal.clientWidth, behavior: 'smooth' });
    }

    function setupDialog(zoomEl) {
      if (zoomEl._zoomSetup) return;
      zoomEl._zoomSetup = true;

      var dialog = zoomEl.querySelector('dialog');
      var gallery = zoomEl.querySelector('.dialog-zoomed-gallery');
      if (!dialog || !gallery) return;

      /* Redirect gallery scroll → dialog so zoom-dialog.js#handleScroll fires */
      gallery.addEventListener('scroll', function () {
        dialog.dispatchEvent(new Event('scroll'));
      }, { passive: true });

      /* Click outside image (on dialog backdrop / empty area) → close */
      dialog.addEventListener('click', function (e) {
        var target = e.target;
        /* Close when clicking the dialog itself (backdrop area) or directly on the gallery <ul> */
        if (target === dialog || target === gallery) {
          if (typeof zoomEl.close === 'function') {
            zoomEl.close();
          } else {
            dialog.close();
          }
        }
      });

      /* Inject prev / next arrows */
      var count = gallery.querySelectorAll('li').length;
      if (count < 2) return;

      /* Remove any previously injected arrows (e.g. after variant change) */
      dialog.querySelectorAll('.zoom-nav-btn').forEach(function (el) { el.remove(); });

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'zoom-nav-btn zoom-nav-prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.innerHTML = '&#8249;';

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'zoom-nav-btn zoom-nav-next';
      next.setAttribute('aria-label', 'Next image');
      next.innerHTML = '&#8250;';

      prev.addEventListener('click', function (e) {
        e.stopPropagation();
        var i = getGalleryIndex(gallery);
        navigate(zoomEl, i > 0 ? i - 1 : count - 1);
      });

      next.addEventListener('click', function (e) {
        e.stopPropagation();
        var i = getGalleryIndex(gallery);
        navigate(zoomEl, i < count - 1 ? i + 1 : 0);
      });

      dialog.appendChild(prev);
      dialog.appendChild(next);
    }

    function initAll() {
      document.querySelectorAll('zoom-dialog').forEach(setupDialog);
    }

    document.addEventListener('DOMContentLoaded', initAll);

    /* Re-initialize when media-gallery is replaced after a variant/color change */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.tagName === 'MEDIA-GALLERY') {
            node.querySelectorAll('zoom-dialog').forEach(function (zd) {
              zd._zoomSetup = false;
              setupDialog(zd);
            });
          }
          if (node.tagName === 'ZOOM-DIALOG') {
            node._zoomSetup = false;
            setupDialog(node);
          }
        });
      });
    });

    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  })();

  /* Cursor-following zoom: update transform-origin to mouse position */
  (function () {
    function attachHoverZoom(gallery) {
      gallery.querySelectorAll('.product-media-container--zoomable').forEach(function (container) {
        if (container._hoverZoom) return;
        container._hoverZoom = true;
        container.addEventListener('mousemove', function (e) {
          var rect = container.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
          var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
          var img = container.querySelector('.product-media__image');
          if (img) img.style.transformOrigin = x + '% ' + y + '%';
        });
        container.addEventListener('mouseleave', function (e) {
          var parentGallery = container.closest('media-gallery');
          if (parentGallery && e.relatedTarget && parentGallery.contains(e.relatedTarget)) return;
          var img = container.querySelector('.product-media__image');
          if (img) img.style.transformOrigin = 'center center';
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('media-gallery').forEach(attachHoverZoom);
    });

    var zoomObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element && node.tagName === 'MEDIA-GALLERY') attachHoverZoom(node);
        });
      });
    });
    document.addEventListener('DOMContentLoaded', function () {
      zoomObserver.observe(document.body, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    /*
   * The size dropdown starts on "Valitse koko" instead of a preselected size,
   * and add to cart is blocked until the customer picks one. Sold-out sizes
   * stay visible (labelled in Liquid). The real option keeps its selected
   * attribute the whole time, so variant-picker.js works unchanged; only the
   * displayed value is the placeholder.
   */
  (function () {
    var chosen = {};
    var ERROR_CLASS = 'ww-size-error';

    function pickerKey(picker) {
      return (picker.dataset.sectionId || '') + ':' + (picker.dataset.productId || '');
    }

    function isPending(select) {
      var picker = select.closest('variant-picker');
      return !!picker && !chosen[pickerKey(picker)];
    }

    function clearError(select) {
      var wrapper = select.closest('.variant-option--dropdowns');
      var error = wrapper && wrapper.querySelector('.' + ERROR_CLASS);
      if (error) error.remove();
    }

    function showError(select) {
      var wrapper = select.closest('.variant-option--dropdowns');
      if (!wrapper) return;
      if (!wrapper.querySelector('.' + ERROR_CLASS)) {
        var error = document.createElement('p');
        error.className = ERROR_CLASS;
        error.setAttribute('role', 'alert');
        error.textContent = 'Valitse koko ennen kuin lisäät tuotteen ostoskoriin.';
        wrapper.appendChild(error);
      }
      select.focus();
    }

    function applyPlaceholders() {
      document.querySelectorAll('select[data-ww-size-select]').forEach(function (select) {
        if (isPending(select) && select.selectedIndex !== 0) select.selectedIndex = 0;
      });
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyPlaceholders();
      });
    }

    /* Capture phase, so the size counts as chosen before variant-picker.js re-renders. */
    document.addEventListener(
      'change',
      function (event) {
        var select = event.target;
        if (!(select instanceof HTMLSelectElement) || !select.hasAttribute('data-ww-size-select')) return;
        if (select.value === '') return;
        var picker = select.closest('variant-picker');
        if (picker) chosen[pickerKey(picker)] = true;
        clearError(select);
      },
      true
    );

    /* On window, so it runs before Horizon's document-level submit delegation. */
    window.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;

        var scope = form.parentElement;
        while (scope && !scope.querySelector('variant-picker')) scope = scope.parentElement;
        if (!scope) return;

        var select = scope.querySelector('select[data-ww-size-select]');
        if (!select || !isPending(select)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        showError(select);
      },
      true
    );

    function init() {
      /*
       * Deliberately ignores ?variant= in the URL: product cards always link
       * with the first available variant, so it says nothing about the size
       * the customer wants.
       */
      applyPlaceholders();
      document.addEventListener('variant:update', applyPlaceholders);
      /* Covers section re-renders and pickers added later (quick add). */
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
